import { createContext, useContext } from 'react';
import type { AnchorHTMLAttributes, ComponentType } from 'react';

export interface ScreenLinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  to: string;
  /** Query params the app's router serialises itself; a plain `?a=b` in `to` cannot carry arrays. */
  search?: Record<string, unknown>;
}

export type LinkComponent = ComponentType<ScreenLinkProps>;

export const LinkContext = createContext<LinkComponent | null>(null);

export function Link(props: ScreenLinkProps) {
  const Impl = useContext(LinkContext);
  if (Impl === null) throw new Error('Link must be used inside <AppUiProvider>');
  return <Impl {...props} />;
}
